//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data() {
        return {
            isDefault: false,
        };
    },

    methods: {
        validateFn(item, editItem) {
            delete editItem.isDefault;

            return true;
        },
        async postSaveFn(editItem, op) {
            const setting = $.settings.find(s => s.key === 'defaultCategoryId');
            const isCurrentlyDefault = (setting.value === editItem.id);

            if (op === 'archive') {
                this.isDefault = false;
            }

            const value = this.isDefault ? editItem.id : null;

            if (this.isDefault !== isCurrentlyDefault) {
                $.settings = await $.apiUpdateMany('settings', [{ ...setting, value }]);
            }
        },
        onDetailInit(item, editItem) {
            this.isDefault = ($.getSetting('defaultCategoryId') === editItem.id);
        },
    },
};
